var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagSriLanka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25001e-05 2.79346H0V29.2282H6.25001e-05V16.0109V2.79346Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8365 32.0107 31.9999 24.8472 31.9999 16.0107C31.9999 7.17417 24.8365 0.0107422 16 0.0107422C7.16343 0.0107422 0 7.17417 0 16.0107C0 24.8472 7.16343 32.0107 16 32.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5223 2.79346H6.98262C6.73712 2.96127 6.49687 3.13596 6.26143 3.31677L4.87012 16.0108L6.26143 28.7048C6.49687 28.8857 6.73712 29.0604 6.98262 29.2281H12.5223V2.79346Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.10352e-05 16.011C6.10352e-05 21.1826 2.45432 25.7802 6.26095 28.705V3.31689C2.45432 6.24178 6.10352e-05 10.8394 6.10352e-05 16.011Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7392 9.76465V10.165L25.754 10.1672L25.7392 9.76465Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7244 20.1847H27.7098L26.4345 21.5761V24.3587H23.6519V22.9674H25.0432V20.1847H18.7823V21.9239H17.391V18.6094C16.9641 18.2273 16.6953 17.6722 16.6953 17.0543V8.01084C16.6953 6.85828 17.6297 5.9239 18.7823 5.9239V18.7935H21.5649L22.5197 17.9978C22.3529 17.6006 22.2605 17.1644 22.2605 16.7065V14.6196H20.1736V10.4457H24.3475C24.3475 9.75009 25.391 9.05441 25.391 9.05441C25.391 9.05441 26.4345 9.75003 26.4345 10.4457V11.4892V14.6197C27.2084 14.6289 28.4381 14.6088 29.7665 14.6197C29.4175 14.0097 29.2171 13.2859 29.2171 12.5327C29.2171 11.3052 29.7471 10.2015 30.5907 9.43778C29.3747 6.74309 27.4343 4.44546 25.0176 2.79346H14.6084V29.2283H25.0177C27.9564 27.2194 30.1907 24.2562 31.2747 20.7851L30.7244 20.1847Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagSriLanka);
export default __webpack_public_path__ + "static/media/flag_sri_lanka.93fe34ded20c8ce57ed7a02e1975c1e5.svg";
export { ForwardRef as ReactComponent };